import { __rest } from "tslib";
/**
 * Removes __typename keys recursively from generated GraphQL survey object.
 *
 * Useful for using the same survey object as an input variable for survey
 * revision operations.
 */
const removeBuildWithAISurveyTypenames = _a => {
  var {
      __typename: _,
      surveyEntity: __,
      questions
    } = _a,
    survey = __rest(_a, ["__typename", "surveyEntity", "questions"]);
  return Object.assign(Object.assign({}, survey), {
    questions: questions.map(_a => {
      var {
          __typename: _
        } = _a,
        question = __rest(_a, ["__typename"]);
      return question;
    })
  });
};
export default removeBuildWithAISurveyTypenames;